export enum FinancialRatio {
  QUICK_RATIO = 'quickRatio',
  CURRENT_RATIO = 'currentRatio',
  GROSS_MARGIN = 'grossMargin',
  NET_PROFIT_MARGIN = 'netProfitMargin',
  INTEREST_BANK_LOAN = 'interestBankLoan',
  EBITDA = 'ebitda',
  RETURN_ON_ASSETS = 'returnOnAssets',
  SHORT_DEBT_TO_EQUITY_RATIO = 'shortDebtToEquityRatio',
  DEBT_TO_EQUITY_RATIO = 'debtToEquityRatio',
  CASH_RATIO = 'cashRatio',
  DEBT_TO_ASSETS_RATIO = 'debtToAssetsRatio',
  DEBT_TO_SERVICE_COVERAGE_RATIO = 'debtServiceCoverageRatio',
  INTEREST_COVERAGE_RATIO = 'interestCoverageRatio',
  LEVERAGE_RATIO = 'leverageRatio',
  ABSOLUTE_LIQUIDITY = 'absoluteLiquidity',
  EBITDA_MARGIN = 'ebitdaMargin',
  WORKING_CAPITAL = 'workingCapital',
  FREE_CASHFLOW = 'freeCashFlow',
  EQUITY_TO_LT_ASSETS = 'equityToLTAssets',
  OPERATING_MARGIN = 'operatingMargin',
  RETURN_ON_EQUITY = 'returnOnEquity',
  FREE_CASHFLOW_RATIO = 'freeCashflowRatio',
  GROSS_BURN_RATE = 'grossBurnRate',
  GROSS_BURN = 'grossBurn',
  RUNWAY = 'runway',
  REVENUE_CONCENTRATION_INDEX = 'revenueConcentrationIndex',
  DAYS_SALES_RECEIVABLES_INDEX = 'daysSalesReceivablesIndex',
  GROSS_MARGIN_INDEX = 'grossMarginIndex',
  MONTHLY_RECURRING_REVENUE = 'monthlyRecurringRevenue',
  MONTHLY_RECURRING_REVENUE_RATE = 'monthlyRecurringRevenueRate',
  ANNUAL_RECURRING_REVENUE = 'annualRecurringRevenue',
  ANNUAL_RECURRING_REVENUE_RATE = 'annualRecurringRevenueRate',
  ASSET_QUALITY_INDEX = 'assetQualityIndex',
  SALES_MARGIN_INDEX = 'salesGrowthIndex',
  DEPRECIATION_INDEX = 'depreciationIndex',
  SGA_EXPENSES_INDEX = 'sgaExpensesIndex',
  LEVERAGE_INDEX = 'leverageIndex',
  TOTAL_ACCRUALS_TOTAL_ASSETS = 'totalAccrualsTotalAssets',
  ASSET_TURNOVER_RATIO = 'assetTurnoverRatio',
  AVERAGE_COLLECTION_PERIOD = 'averageCollectionPeriod',
  PAYABLES_CONVERSION_PERIOD = 'payablesConversionPeriod',
  AVERAGE_OUTSTANDING_RECEIVABLES_BALANCE = 'averageOutstandingReceivablesBalance',
  AVERAGE_OUTSTANDING_PAYABLES_BALANCE = 'averageOutstandingPayablesBalance',
  ACCOUNTS_RECEIVABLE_TURNOVER_RATIO = 'accountsReceivableTurnoverRatio',
  ACCOUNTS_PAYABLE_TURNOVER_RATIO = 'accountsPayableTurnoverRatio',
  DAYS_PAYABLE_OUTSTANDING = 'daysPayableOutstanding',
  DAYS_SALES_OUTSTANDING = 'daysSalesOutstanding',
  INVENTORY_TURNOVER_RATIO = 'inventoryTurnoverRatio',
  CHURN_RATE = 'churnRate',
  DISTANCE_TO_DEFAULT = 'distanceToDefault',
  PROBABILITY_OF_DEFAULT = 'probabilityOfDefault',
  LIQUIDATION_VALUE = 'liquidationValue',
  RECEIVABLES_TURNOVER_RATIO = 'receivablesTurnoverRatio',
  ENTERPRISE_VALUE = 'enterpriseValue',
  DEBT_TO_ENTERPRISE_VALUE = 'debtToEnterpriseValue',
}
